<div class="container mx-auto mt-8">
  <h2 class="text-xl mb-8">Login</h2>
  <jofi-login></jofi-login>
</div>
